import { Component } from "react";
import { createRoot } from "react-dom/client";
import PopupComponent from "../component";
import data from "../../data.json";
import { SHARE_COPY_RESET_MS } from "../constants";
import {
  generateNewMood,
  getMoodByName,
  moodToPopupState,
} from "../shuffle-moods";

class PopupDemoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slowControl: 1,
      reverbAmount: 0,
      videoFx: null,
      videoFxs: data.videoFxs,
      lowPassMode: false,
      lowPassCutoff: 1500,
      highPassMode: false,
      highPassCutoff: 500,
      bitcrusherMode: false,
      bitcrusherAmount: 0.45,
      bassBoostMode: false,
      bassBoostAmount: 0.5,
      phaserMode: false,
      phaserAmount: 0.5,
      echoMode: false,
      echoAmount: 0.5,
      lofiTapeMode: false,
      lofiHissVolume: 1,
      rainyMode: false,
      rainVolume: 0.6,
      coffeeShopMode: false,
      coffeeShopVolume: 0.6,
      vinylCrackleMode: false,
      vinylCrackleVolume: 0.55,
      preservePitchMode: false,
      darkMode: props.darkMode ?? false,
      shareMediaOptIn: false,
      trackName: "Demo Track",
      url: "https://www.youtube.com/watch?v=demo",
      sharingStatus: null,
      isSlowedEnabled: true,
      isFeedbackEnabled: true,
      isRateAppEnabled: true,
    };
  }

  componentWillUnmount() {
    clearTimeout(this.shareCopyResetTimer);
  }

  scheduleShareCopyReset() {
    clearTimeout(this.shareCopyResetTimer);
    this.shareCopyResetTimer = setTimeout(() => {
      this.setState({ sharingStatus: null });
    }, SHARE_COPY_RESET_MS);
  }

  render() {
    const {
      isHeaderVisible,
      isPro,
      isProFeaturesLocked,
      trialMode,
      remainingTrialDays,
      testMode,
      onUpgradeClick,
      onFeedbackClick,
      onHelpClick,
      onChangelogClick,
      onRateAppClick,
      onCustomizeShortcut,
      onDarkModeChanged,
      hideManagePlan,
    } = this.props;
    const {
      isSlowedEnabled,
      slowControl,
      reverbAmount,
      lowPassMode,
      lowPassCutoff,
      highPassMode,
      highPassCutoff,
      bitcrusherMode,
      bitcrusherAmount,
      bassBoostMode,
      bassBoostAmount,
      phaserMode,
      phaserAmount,
      echoMode,
      echoAmount,
      lofiTapeMode,
      lofiHissVolume,
      rainyMode,
      rainVolume,
      coffeeShopMode,
      coffeeShopVolume,
      vinylCrackleMode,
      vinylCrackleVolume,
      preservePitchMode,
      darkMode,
      videoFxs,
      videoFx,
      isFeedbackEnabled,
      isRateAppEnabled,
      shareMediaOptIn,
      trackName,
      url,
      sharingStatus,
    } = this.state;

    return (
      <PopupComponent
        isHeaderVisible={isHeaderVisible || true}
        isSlowedEnabled={isSlowedEnabled}
        isFeedbackEnabled={isFeedbackEnabled}
        isRateAppEnabled={isRateAppEnabled}
        isPro={isPro}
        isProFeaturesLocked={isProFeaturesLocked}
        hideManagePlan={hideManagePlan}
        trialMode={trialMode}
        remainingTrialDays={remainingTrialDays}
        testMode={testMode}
        slowControl={slowControl}
        reverbAmount={reverbAmount}
        videoFx={videoFx}
        videoFxs={videoFxs}
        lowPassMode={lowPassMode}
        lowPassCutoff={lowPassCutoff}
        highPassMode={highPassMode}
        highPassCutoff={highPassCutoff}
        bitcrusherMode={bitcrusherMode}
        bitcrusherAmount={bitcrusherAmount}
        bassBoostMode={bassBoostMode}
        bassBoostAmount={bassBoostAmount}
        phaserMode={phaserMode}
        phaserAmount={phaserAmount}
        echoMode={echoMode}
        echoAmount={echoAmount}
        lofiTapeMode={lofiTapeMode}
        lofiHissVolume={lofiHissVolume}
        rainyMode={rainyMode}
        rainVolume={rainVolume}
        coffeeShopMode={coffeeShopMode}
        coffeeShopVolume={coffeeShopVolume}
        vinylCrackleMode={vinylCrackleMode}
        vinylCrackleVolume={vinylCrackleVolume}
        preservePitchMode={preservePitchMode}
        darkMode={darkMode}
        shareMediaOptIn={shareMediaOptIn}
        trackName={trackName}
        url={url}
        sharingStatus={sharingStatus}
        onUpgradeClick={onUpgradeClick}
        onFeedbackClick={onFeedbackClick}
        onChangelogClick={onChangelogClick}
        onHelpClick={onHelpClick}
        onRateAppClick={onRateAppClick}
        onCustomizeShortcut={onCustomizeShortcut}
        onSlowedToggle={(value) => {
          this.setState({ isSlowedEnabled: value });
        }}
        onSlowControlChange={(value) => {
          this.setState({ slowControl: value, isSlowedEnabled: true });
        }}
        onVideoFxChange={(value) => {
          this.setState({ videoFx: value, isSlowedEnabled: true });
        }}
        onLowPassModeChange={(value) => {
          this.setState({ lowPassMode: value });
        }}
        onLowPassCutoffChange={(value) => {
          this.setState({ lowPassCutoff: value });
        }}
        onHighPassModeChange={(value) => {
          this.setState({ highPassMode: value });
        }}
        onHighPassCutoffChange={(value) => {
          this.setState({ highPassCutoff: value });
        }}
        onBitcrusherModeChange={(value) => {
          this.setState({ bitcrusherMode: value });
        }}
        onBitcrusherAmountChange={(value) => {
          this.setState({ bitcrusherAmount: value });
        }}
        onBassBoostModeChange={(value) => {
          this.setState({ bassBoostMode: value });
        }}
        onBassBoostAmountChange={(value) => {
          this.setState({ bassBoostAmount: value });
        }}
        onPhaserModeChange={(value) => {
          this.setState({ phaserMode: value });
        }}
        onPhaserAmountChange={(value) => {
          this.setState({ phaserAmount: value });
        }}
        onEchoModeChange={(value) => {
          this.setState({ echoMode: value });
        }}
        onEchoAmountChange={(value) => {
          this.setState({ echoAmount: value });
        }}
        onLofiTapeModeChange={(value) => {
          this.setState({ lofiTapeMode: value });
        }}
        onLofiHissVolumeChange={(value) => {
          this.setState({ lofiHissVolume: value });
        }}
        onRainyModeChange={(value) => {
          this.setState({ rainyMode: value });
        }}
        onRainVolumeChange={(value) => {
          this.setState({ rainVolume: value });
        }}
        onCoffeeShopModeChange={(value) => {
          this.setState({ coffeeShopMode: value });
        }}
        onCoffeeShopVolumeChange={(value) => {
          this.setState({ coffeeShopVolume: value });
        }}
        onVinylCrackleModeChange={(value) => {
          this.setState({ vinylCrackleMode: value });
        }}
        onVinylCrackleVolumeChange={(value) => {
          this.setState({ vinylCrackleVolume: value });
        }}
        onPreservePitchModeChange={(value) => {
          this.setState({ preservePitchMode: value });
        }}
        onAIShuffle={() => {
          const mood = generateNewMood();
          this.setState(moodToPopupState(mood));
          return Promise.resolve(mood);
        }}
        onApplyMood={(moodOrName) => {
          const mood =
            typeof moodOrName === "string"
              ? getMoodByName(moodOrName)
              : moodOrName;
          if (!mood) return Promise.resolve(null);
          this.setState(moodToPopupState(mood));
          return Promise.resolve(mood);
        }}
        onDarkModeChange={(value) => {
          this.setState({ darkMode: value });
          onDarkModeChanged?.(value);
        }}
        onReverbAmountChange={(value) => {
          this.setState({ reverbAmount: value, isSlowedEnabled: true });
        }}
        onShareMediaOptInChange={(value) => {
          this.setState({ shareMediaOptIn: value });
        }}
        onCopyShareUrl={(value) => {
          this.setState({
            sharingStatus: { type: value, value: "copied" },
          });
          if (value === "copy") this.scheduleShareCopyReset();
        }}
      />
    );
  }
}

self.Slowed.Components.PopupDemo = PopupDemoComponent;

self.Slowed.mountPopupDemo = (element, props) => {
  element._slowedRoot = element._slowedRoot || createRoot(element);
  element._slowedRoot.render(<PopupDemoComponent {...props} />);
};

export default PopupDemoComponent;
